<template>
  <div class="dialog-share">
    <mt-popup v-model="isVisible" popup-transition="popup-fade" :closeOnClickModal="true">
      <div class="arrow" @click="isVisible = false"></div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  name: 'dialogShare',
  data () {
    return {
      dialogName: 'share'
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.$store.state.dialogVisible[this.dialogName]
      },
      set (value) {
        this.$store.dispatch('dialogVisible', { name: this.dialogName, visible: value })
      }
    }
  },
  methods: {

  },
  created () {
    // console.log(this)
    // this.$store.dispatch('dialogVisible', { name: this.dialogName, visible: true });
  },
  mounted () {

  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../assets/less/variable.less';
@import '../assets/less/function_px.less';
.mint-popup {
  top: 0;
  width: 100%;
  left: 0;
  .translate(0,0) !important;
  background: none;
  border: none;
  overflow: visible;
}
.arrow {
  .bgImg('../../assets/images/sprites/share_arrow.png',0.6);
  position: absolute;
  top: 20px;
  right: 40px;
  animation-name: flash;
  animation-fill-mode: both;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
}
.text {
  position: absolute;
  top: 80px;;
  right: 20px;;
  color: #fff;
  font-size: 14px;
  text-align: right;
}
// .hint {
//   .bgImg('../../assets/images/share_hint.png',0.5);
//   position: absolute;
//   .bgSprite(h);
//   top: 100px;
// }
@keyframes flash {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
